import styled from '@emotion/styled';

import { TcolorsPaletteFromBO } from '../types';

export const StyledLink = styled('a')(
  ({
    colorsPaletteFromBO,
    isCurrentUrl,
  }: {
    colorsPaletteFromBO: TcolorsPaletteFromBO;
    isCurrentUrl: boolean;
  }) => ({
    color: '#4e4e4e',
    display: 'table',
    position: 'relative',
    textDecoration: 'none',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    textShadow: isCurrentUrl ? '0.5px 0 0 currentColor' : 'none',
    '&:hover': {
      textShadow: '0.5px 0 0 currentColor',
      '&:after': {
        transform: 'scaleX(1)',
      },
    },
    '&:after': {
      backgroundColor: colorsPaletteFromBO.main,
      bottom: '-0.5rem',
      content: '""',
      height: '0.2rem',
      left: 0,
      position: 'absolute',
      transform: isCurrentUrl ? 'scaleX(1)' : 'scaleX(0)',
      transition: isCurrentUrl ? 'none' : 'transform 0.3s ease-in-out',
      width: '100%',
    },
  }),
);
